import * as Logger from './logger.js'
import * as Utils from './utils.js';
import { HSCard } from './card.js';
import { UserSession } from './session.js';
import styles from './link-card.css';
import template from './link-card.html';


export class HSLinkCard extends HSCard {
    linkEnabled = false;

    constructor() {
        super();
    }

    onLoad() {
    }

    init(config) {
        super.init(config);
        this.title = this.config.title;
        this.link = this.config.linkText;
        if (this.config.titleTemplate) {
            this.title = Utils.evaluate(this.config.titleTemplate, [ 'session' ], [ UserSession ]);
        }
        if (this.config.linkTemplate) {
            this.link = Utils.evaluate(this.config.linkTemplate, [ 'session' ], [ UserSession ]);
        }
        this.loadTemplate(template);
        this.loadStyles(styles);

        if (this.config.onclick) {
            this.onEvent('click', () => { 
                this.runAction({ ...this.config.onclick });
            });
        }

        this.reloadData();
    }

    runAction(opts, context = {}) {
        if (!this.linkEnabled) {
            Logger.debug("LinkCard: link is disabled, ignoring action");
            return;
        }
        super.runAction(opts, context);
    }

    async reloadData() {
        // conditional link display based on session data
        const linkElement = this.shadowRoot.querySelector('.footer-link');
        const iconElement = this.shadowRoot.querySelector('.footer-icon');
        if (!this.config.showLinkIf || Utils.filter(Utils.compileFilters(this.config.showLinkIf, [ 'session' ]), [ UserSession ])) {
            this.linkEnabled = true;
            this.classList.add('clickable');
            linkElement.classList.remove('hide');
            iconElement.classList.remove('hide');
        } else {
            this.linkEnabled = false;
            this.classList.remove('clickable');
            linkElement.classList.add('hide');
            iconElement.classList.add('hide');
        }
        //if (window.location.href.includes('localhost')) { // for local development only } else {
        // fetch the source data
        if (this.config.src) {
            const json = await this.getSourceData(this.config.src);
            if (this.config.field) {
                this.setValue(json?.[0]?.[this.config.field] ?? 0);
            }
        }
        if (this.config.titleTemplate) {
            this.title = Utils.evaluate(this.config.titleTemplate, [ 'session' ], [ UserSession ]);
            const titleElement = this.shadowRoot.querySelector('.title');
            if (titleElement) {
                titleElement.textContent = this.title;
            } else {
                Logger.warn("LinkCard: failed to find/update title");
            }
        }
        this.hideLoading();
    }
}
customElements.define('hs-link-card', HSLinkCard);

